module.exports = __webpack_public_path__ + "img/youtube.a51ab7ed.svg";